import React, { useEffect, useState } from 'react'
import { Box, Button, Typography, Modal } from '@mui/material';
import calculateAge from '../../utils/calculateAge';
import { encryptUtility } from '../../utils/crypt-module/encrypt';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useAuth } from '../../custom-hooks/useAuth';
import { connect } from 'react-redux';
import { dashboardActions } from '../../redux-utils/actions/dashboard-actions';
import '../../swal.css';
import Loader from '../Loader';
import { useTranslation } from 'react-i18next';
import { FormatDateString } from '../../utils/FormatDate';

const { participantaArchiveAction, participantDeleteAction } = dashboardActions;

function ViewParticipantInfo( {handleClose, open, style, participant, handleEditParticipant,participantArchiveDispatchAction, buttonLabel, participantDeleteDispatchAction, participantDeleteState, handleArchiveUpdate} ) {

 
    const ReactSwal = withReactContent(Swal);
    const { getLogin } = useAuth();
    const loginStorage = JSON.parse(getLogin());
    const [archiveType, setArchiveType] = useState(null);
    const {t} = useTranslation();
    

    const archiveParticipant = (type) => {
        setArchiveType(type);
        Swal.fire({
            title: `${t('swal-messages.Are you sure')}?`,
            text: `${t('swal-messages.Do you really want to')} ${type === 'yes' ? `${t('swal-messages.Archive')}` : `${t('swal-messages.Unarchive')}`} ${t('swal-messages.This participant')}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `${t('swal-messages.Yes, do it')}!`,
            cancelButtonText: `${t('swal-messages.No, cancel')}!`,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#FDB315', 
            customClass: {
                confirmButton: 'custom-confirm-button-class',
                cancelButton: 'custom-cancel-button-class'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const params = {
                    publicKey: process.env.REACT_APP_PUB_KEY_1,
                    formData: {
                        is_archived: type,
                    },
                };
    
                encryptUtility(params)
                    .then((encryptedData) => {
                        const form_values = {
                            id: participant.id,
                            token: loginStorage && loginStorage.loginData.data.token,
                            ...encryptedData,
                        };
    
                        participantArchiveDispatchAction(form_values);
                    });
            }
        });
    };
    


    const deleteParticipant = (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${t('swal-messages.Are you sure')}?`,
            text: `${t('swal-messages.Do you really want to')} ${t('swal-messages.Delete')} ${t('swal-messages.This participant')}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `${t('swal-messages.Yes, do it')}!`,
            cancelButtonText: `${t('swal-messages.No, cancel')}!`,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#FDB315', 
            customClass: {
                confirmButton: 'custom-confirm-button-class',
                cancelButton: 'custom-cancel-button-class'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const form_values = {
                    id:participant.id,
                    token: loginStorage && loginStorage.loginData.data.token
                }
                participantDeleteDispatchAction(form_values)
            }
        });
    };

    
    useEffect(() => {
        if (participantDeleteState.status === 'participant_delete_success') {
            handleClose();
            Swal.fire({
                title: `${t('swal-messages.Success')}!`,
                text: `${t('swal-messages.Participant')} ${t('swal-messages.Deleted')} ${t('swal-messages.Successfully')}!`,
                icon: 'success',
            });
        } else if (participantDeleteState.status === 'participant_delete_failed') {
            handleClose();
            Swal.fire({
                title: `${t('swal-messages.Error')}!`,
                text: `${t('swal-messages.There was a problem')} ${t('swal-messages.Deleting')} ${t('swal-messages.The participant')}!`,
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    }, [participantDeleteState.status, archiveType, handleClose, handleArchiveUpdate, participant.id]);
    
    
    useEffect(() => {
        if (archiveType) {
            if (participantDeleteState.status === 'participant_archive_success') {
                handleClose();
                setArchiveType(null);
                Swal.fire({
                    title: `${t('swal-messages.Success')}!`,
                    text: `${t('swal-messages.Participant')} ${archiveType === 'yes' ? `${t('swal-messages.Archived')}` : `${t('swal-messages.Unarchived')}`} ${t('swal-messages.Successfully')}.`,
                    icon: 'success',
                });
            } else if (participantDeleteState.status === 'participant_archive_failed') {
                handleClose();
                setArchiveType(null);
                Swal.fire({
                    title: `${t('swal-messages.Error')}!`,
                    text: `${t('swal-messages.There was a problem')} ${archiveType === 'yes' ? `${t('swal-messages.Archiving')}` : `${t('swal-messages.Unarchiving')}`} ${t('swal-messages.The participant')}.`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                });
            }

            const updateInfo = {
                archiveStatus: participantDeleteState.status,
                archiveId: participant.id
            }
            handleArchiveUpdate(updateInfo);
        }
    }, [participantDeleteState.status]);


  return (
    <>
        <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className='-z-50 relative'
        >
            <Box sx={style}>
            {participantDeleteState.status === "participant_archive_start" && <Loader componentType="edit-participant-modal" />}
                <form>
                    <div className="w-full h-[85vh] rounded-lg bg-white p-10 pt-0 overflow-auto relative">
                        <div className="flex justify-between items-center w-auto bg-white h-20 sticky top-0"> 
                            <Typography 
                            variant="h4" 
                            sx={{ 
                                color: '#2F4858', 
                                fontWeight: '500',
                                fontSize: '28px' 
                            }}
                            >
                                {participant.first_name} {participant.last_name}
                            </Typography>
                            <div className="flex gap-5 items-center">
                                <Button
                                onClick = {() => participant.is_archived === "yes" ? archiveParticipant('no') : archiveParticipant('yes')}
                                variant="outlined"
                                sx={{
                                    color: '#FDB315',
                                    px: 2,
                                    py: '0.39rem',
                                    borderRadius: '999px',
                                    border: '2px solid #FDB315',
                                    fontWeight: 600,
                                    fontSize: '12px',
                                    '&:hover': {
                                    border: '2px solid #FDB315',
                                    backgroundColor: 'transparent',
                                    color: '#FDB315',
                                    }
                                }}
                                >
                                {participant.is_archived === 'yes' ? `${t('modals.Unarchive')}` : `${t('modals.Archive')}`}
                                </Button>
                                <Button
                                    onClick={buttonLabel ? handleEditParticipant : deleteParticipant}
                                    variant="contained"
                                    sx={{
                                    backgroundColor: '#FDB315',
                                    px: 3,
                                    py: '0.59rem',
                                    borderRadius: '999px',
                                    color: 'white',
                                    fontWeight: 600,
                                    fontSize: '12px',
                                    '&:hover': {
                                    backgroundColor: '#FDB315',
                                    color: 'white',
                                    }
                                    }}
                                >
                                    {buttonLabel ? `${t('modals.Edit')}` : `${t('modals.Delete')}`}
                                </Button>
                                <div onClick={handleClose} className='cursor-pointer bg-[#EFEFEF] hover:bg-[#eeeeff] w-10 h-10 flex items-center justify-center rounded-full'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M18 6l-12 12" />
                                        <path d="M6 6l12 12" />
                                    </svg>
                                </div> 
                            </div>
                        </div>
                        <div className="mt-5">
                            <div className="border shadow-sm rounded-lg p-5">
                                <Typography sx={{ 
                                color: '#FF6723', 
                                fontWeight: '600',
                                fontSize: '16px' 
                                }}>
                                    {t('modals.Administrative Information')}
                                </Typography>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Fee Paid')}</label>
                                        <input type="text" value={`${participant.is_fee_paid}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Fee Amount')}</label>
                                        <input type="text" value={`${participant.fee_amount}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-3">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Fee Payment Date')}</label>
                                        <input type="text" value={`${FormatDateString(participant.payment_date) ?? 'N/A'}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Agreement Signed')} </label>
                                        <input type="text" value={`${participant.agreement_signed}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-3">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Media Consent')}</label>
                                        <input type="text" value={`${participant.media_allowed}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Confirmation Email Sent')}</label>
                                        <input type="text" value={`${participant.confirmation_email_sent}`} className="border px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                            </div>
                            <div className="border rounded-lg p-5 mt-5">
                                    <Typography                         
                                    sx={{ 
                                    color: '#FF6723', 
                                    fontWeight: '600',
                                    fontSize: '16px' 
                                    }}>
                                        {t('modals.Participant Information')}
                                    </Typography>
                                    <div className="flex gap-5 mt-4">
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Full Name')}</label>
                                            <input type="text" value={`${participant.first_name} ${participant.last_name}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Gender')}</label>
                                            <input type="text" value={`${participant.gender}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                    </div>
                                    <div className="flex gap-5 mt-3">
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Date of Birth')}</label>
                                            <input type="text" value={`${FormatDateString(participant.date_of_birth)}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Age')}</label>
                                            <input type="text" value={`${calculateAge(participant.date_of_birth)}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                    </div>
                            </div>
                            <div className="border rounded-lg p-5 mt-5">
                                    <Typography 
                                    sx={{ 
                                    color: '#FF6723', 
                                    fontWeight: '600',
                                    fontSize: '16px' 
                                    }}>
                                        {t('modals.Guardian Information')}
                                    </Typography>
                                    <div className="flex gap-5 mt-4">
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Father\'s Full Name')}</label>
                                            <input type="text" value={`${participant.father}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Mother\'s Full Name')}</label>
                                            <input type="text" value={`${participant.mother}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                    </div>
                                    <div className="flex gap-5 mt-4">
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.City')}</label>
                                            <input type="text" value={`${participant.city}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Street')}</label>
                                            <input type="text" value={`${participant.street}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                    </div>
                                    <div className="flex gap-5 mt-4">
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.House Number')}</label>
                                            <input type="text" value={`${participant.house_number}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Zip Code')}</label>
                                            <input type="text" value={`${participant.zip_code}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                    </div>
                                    <div className="flex gap-5 mt-4">
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Landline')}</label>
                                            <input type="text" value={`${participant.landline}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Mobile')}</label>
                                            <input type="text" value={`${participant.mobile}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                    </div>
                                    <div className="flex gap-5 mt-4">
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Email Address')}</label>
                                            <input type="text" value={`${participant.email}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                    </div>
                            </div>
                            <div className="border rounded-lg p-5 mt-5">
                                <Typography 
                                    sx={{ 
                                    color: '#FF6723', 
                                    fontWeight: '600',
                                    fontSize: '16px' 
                                    }}>
                                        {t('modals.Emergency Contact Information')}
                                </Typography>
                                    <div className="flex gap-5 mt-4">
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Full Name')}</label>
                                            <input type="text" value={`${participant.father}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                        <div className="flex flex-col w-[50%]">
                                            <label className="font-medium text-[14px]">{t('modals.Mobile')}</label>
                                            <input type="text" value="(316) 555-0116" className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                        </div>
                                    </div>
                            </div>
                            <div className="border rounded-lg p-5 mt-5">
                                <Typography 
                                sx={{ 
                                    color: '#FF6723', 
                                    fontWeight: '600',
                                    fontSize: '16px' 
                                }}>{t('modals.Other')}</Typography>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Friend 1')}</label>
                                        <input type="text" value={`${participant.friend_1}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Friend 2')}</label>
                                        <input type="text" value={`${participant.friend_2}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Sibling In Same Tent')}</label>
                                        <input type="text" value={`${participant.siblings_in_same_tent}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                            </div>
                            <div className="border rounded-lg p-5 mt-5">
                                <Typography 
                                sx={{ 
                                    color: '#FF6723', 
                                    fontWeight: '600',
                                    fontSize: '16px' 
                                    }}
                                    >{t('modals.Activity Information')}</Typography>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Swimming Allowed')}</label>
                                        <input type="text" value={`${participant.swimming_allowed}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Swimming Capability')}</label>
                                        <input type="text" value={`${participant.swimming_capability}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Swimming Badge')}</label>
                                        <input type="text" value={`${participant.swimming_badge}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Tools Allowed')}</label>
                                        <input type="text" value={`${participant.tools_allowed}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                            </div>
                            <div className="border rounded-lg p-5 mt-5">
                                <Typography 
                                sx={{ 
                                    color: '#FF6723', 
                                    fontWeight: '600',
                                    fontSize: '16px' 
                                    }}
                                    >{t('modals.Health Information')}</Typography>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Vaccination Tetanus')}</label>
                                        <input type="text" value={`${participant.vaccination_tetanus}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Vaccination Tetanus Year')}</label>
                                        <input type="text" value={`${participant.vaccination_tetanus_year}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Vaccination FSME')}</label>
                                        <input type="text" value={`${participant.vaccination_fsme}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Vaccination FSME Year')}</label>
                                        <input type="text" value={`${participant.vaccination_fsme_year}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Tick Removal Allowed')}</label>
                                        <input type="text" value={`${participant.tick_removal_allowed}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Allergies')}</label>
                                        <input type="text" value={`${participant.allergies}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Vegetarian')}</label>
                                        <input type="text" value={`${participant.vegetarian}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Food Intolerance')}</label>
                                        <input type="text" value={`${participant.food_intolerance}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Medication Allowed')}</label>
                                        <input type="text" value={`${participant.medication_allowed}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                    <div className="flex flex-col w-[50%]">
                                        <label className="font-medium text-[14px]">{t('modals.Medication')}</label>
                                        <input type="text" value={`${participant.medication}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                                <div className="flex gap-5 mt-4">
                                    <div className="flex flex-col w-full">
                                        <label className="font-medium text-[14px]">{t('modals.Additional Details')}</label>
                                        <input type="text" value={`${participant.additional_details}`} className=" px-4 mt-1 py-2 w-full text-gray-500 rounded-lg bg-[#F9FAFB] outline-none" readOnly/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Box>
        </Modal>
    </>
  )
}


const mapStateToProps = state => ({
    participantDeleteState: state.dashboardState
})

const mapDispatchToProps = dispatch => ({
    participantArchiveDispatchAction: (params) => dispatch(participantaArchiveAction(params)),
    participantDeleteDispatchAction: (params) => dispatch(participantDeleteAction(params)),
})


export default connect(mapStateToProps, mapDispatchToProps)(ViewParticipantInfo)

